import * as effects from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { authActions } from '../../actions';
import {
  FillResendCodeActionPayload,
  ResendCodeActionPayload,
} from '../../typedefs';
import { put } from 'redux-saga/effects';

export function* resendCode({
  payload,
}: PayloadAction<ResendCodeActionPayload>) {
  try {
    yield effects.put(authActions.startFetching());
    const body: string = yield effects.call(JSON.stringify, payload);
    const response: Response = yield effects.apply(api, api.post, [
      { endpoint: 'auth/resend-confirmation-code', body, unsafe: true },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }

    const data: FillResendCodeActionPayload = yield effects.call([
      response,
      'json',
    ]);
    yield put(authActions.setResentCodeTimer(data.verification_code.expire_at));
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(authActions.stopFetching());
  }
}
